import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import PhysicianProfileSidebar from "../Components/PhysicianProfileSidebar";
import Footer from "../Components/Footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PhysicianConsultationTab from "../Components/PhysicianConsultationTab";
import { chat, file, userpatient } from "../Constant/Index";
import { useDispatch, useSelector } from "react-redux";
import {
	getPhysicianappointmentclosesapi,
	physicianBookapointmentdetail,
} from "../network/Network";
import { PHYSICIAN_DETAIL } from "../redux/Slices/AuthSlice";
import Swal from "sweetalert2";

const PhysicianConsultationDetail = () => {
	const { state } = useLocation();
	console.log("State:", state);
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const token = useSelector((state) => state?.Auth?.token);
	const [getappointdetail, setGetappointdetail] = useState("");
	const [isChecked, setIsChecked] = useState(false);
	let currentUrl = window.location.href.split("/");
	const HandleClose = (e) => {
		e.preventDefault();
		setLoading(true);
		getPhysicianappointmentclosesapi(
			token,
			getappointdetail?.booking_detail?.booking_id,
			state?.current_page,
		)
			.then((res) => {
				Swal.fire({
					position: "center",
					icon: "success",
					text: res?.data?.message || "Session ended successfully",
					showConfirmButton: false,
					timer: 1500,
				});
				navigate("/physician-myconsultations");
			})
			.catch((err) => {
				setLoading(false);
				const errorData = err?.response?.data?.errors?.error;

				if (errorData) {
					if (Array.isArray(errorData)) {
						errorData.forEach((msg) =>
							Swal.fire({
								position: "center",
								icon: "error",
								text: msg,
								showConfirmButton: false,
								timer: 2200,
							}),
						);
					} else if (typeof errorData === "string") {
						Swal.fire({
							position: "center",
							icon: "error",
							text: errorData,
							showConfirmButton: false,
							timer: 2200,
						});
					} else if (typeof errorData === "object") {
						Object.values(errorData).forEach((msg) =>
							Swal.fire({
								position: "center",
								icon: "error",
								text: msg,
								showConfirmButton: false,
								timer: 2200,
							}),
						);
					}
				}
			});
	};

	// Get Appoitment detail Api
	useEffect(() => {
		physicianBookapointmentdetail(currentUrl[4], token).then((res) => {
			dispatch(PHYSICIAN_DETAIL(res?.data));
			setGetappointdetail(res?.data);
		});
	}, [currentUrl[4]]);
	// ====================
	const [files, setFiles] = useState([]);

	const handleFileChange = (e) => {
		const newFiles = [...files];
		newFiles[parseInt(e.target.id.split("-").pop(), 10) - 1] =
			e.target.files[0];
		setFiles(newFiles);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
	};

	const handleCheckboxChange = (e) => {
		const checked = e.target.checked;
		setIsChecked(checked);
	};

	console.log(getappointdetail?.booking_detail, "daskkas2");

	return (
		<>
			<Header />
			<PageHeader pagename="Physician Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<PhysicianProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	 mb-3">
									<div className="edit-btn back">
										<Link to="/physician-myconsultations">
											<div className="nav-anchor">
												<i className="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<div className="d-flex align-items-center  justify-content-between w-100">
										<h5 className="main-heading level-6 ps-3 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
											My Consultations
										</h5>
									</div>
								</div>
								{/* <div className="row">
									<div className="col-lg-12">
										<div className="content-qty extra-bg-14 radius-20 p-4 dark-color ">
											<div className="d-flex gap-3 align-items-center">
												<img
													src={
														getappointdetail?.patient_detail?.profile_image_url
													}
													className="img-fluid profie_img"
													alt=""
												/>
												<div>
													<h4 className="main-heading-font level-6 ">
														{getappointdetail?.patient_detail?.title}
													</h4>
													<h5 className="primary-medium-font level-8 extra-color-15">
														Patient
													</h5>
												</div>
												<div className="text-end">
													<button>end session</button>
												</div>
											</div>
										</div>
									</div>
								</div> */}
								<div className="row">
									<div className="col-lg-12">
										<div className="content-qty extra-bg-14 radius-20 p-4 dark-color">
											<div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
												<div className="d-flex gap-3 align-items-center">
													<img
														src={
															getappointdetail?.patient_detail
																?.profile_image_url
														}
														className="img-fluid profie_img"
														alt=""
														style={{
															width: "60px",
															height: "60px",
															borderRadius: "50%",
															objectFit: "cover",
														}}
													/>
													<div>
														<h4 className="main-heading-font level-6">
															{getappointdetail?.patient_detail?.title}
														</h4>
														<h5 className="primary-medium-font level-8 extra-color-15">
															Patient
														</h5>
													</div>
												</div>
												{getappointdetail?.booking_detail?.appointment_status ==
													"Current" && (
													<div>
														<button
															className="btn btn-danger text-white px-4 py-2"
															style={{
																borderRadius: "10px",
																fontWeight: "500",
																boxShadow: "0 2px 8px rgba(255,0,0,0.3)",
																transition: "0.3s",
															}}
															onMouseOver={(e) =>
																(e.currentTarget.style.backgroundColor =
																	"#cc0000")
															}
															onMouseOut={(e) =>
																(e.currentTarget.style.backgroundColor =
																	"#dc3545")
															}
															onClick={(e) => HandleClose(e)}
														>
															{loading ? "Ending..." : "End Session"}
														</button>
													</div>
												)}
											</div>
										</div>
									</div>
								</div>

								<div className="row  pt-4   pb-4">
									<div className="col-lg-12">
										<div className="order-detail-content">
											<div className="row">
												<div className="col-lg-12">
													<div className="details-pharmacy">
														<h4 className="main-heading-font level-6 ">
															Symptoms
														</h4>
														<h5 className="primary-medium-font level-8 extra-color-10">
															{getappointdetail?.booking_detail?.symptoms?.join(
																", ",
															)}
														</h5>
													</div>
												</div>
												<div className="col-lg-12 mt-3">
													<div className="details-pharmacy">
														<h4 className="main-heading-font level-6 ">
															Details
														</h4>
														<h5 className="primary-medium-font level-8 extra-color-10">
															{getappointdetail?.booking_detail?.detail}
														</h5>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<form onSubmit={handleSubmit}>
									<div className="scroll_dv">
										{getappointdetail?.patient_detail?.medical_reports?.map(
											(item, ggindex) => {
												return (
													<div
														className="row input-file-wrapper mb-2"
														key={ggindex}
													>
														<div className="form-group col-lg-12">
															<div className="position-relative">
																<div className="form-group col-lg-12 show_download_file_dv">
																	<div className="pdf-icon d-flex">
																		<i className="fa-solid fa-file-pdf"></i>
																		<p className="mb-0">{item?.file_name}</p>
																	</div>
																	<div className="icon-input">
																		<h4>
																			<a
																				className="download"
																				target="_blank"
																				href={item?.report_url}
																				download={item?.file_name}
																			>
																				Download
																			</a>
																		</h4>
																	</div>
																</div>
															</div>
														</div>
													</div>
												);
											},
										)}
									</div>
								</form>

								{getappointdetail?.booking_detail?.appointment_status ==
								"Upcoming" ? (
									<>
										<div className="row mt-3 border-top pt-4">
											<div className="col-lg-12">
												<Link className="detail-physician-btn calender-bg extra-bg-14 w-100 d-flex align-items-center justify-content-center">
													<span>
														<i className="fa-regular fa-calendar"></i>{" "}
													</span>
													{getappointdetail?.booking_detail?.booking_day}{" "}
													{new Date(
														getappointdetail?.booking_detail?.booking_date,
													).toLocaleDateString("en-GB", {
														day: "2-digit",
														month: "long",
														year: "numeric",
													})}{" "}
													({getappointdetail?.booking_detail?.booking_time})
												</Link>
											</div>
										</div>
									</>
								) : null}

								{/* =============================== */}
								{getappointdetail?.booking_detail?.appointment_status ==
								"Current" ? (
									<>
										<div className="row border-top pt-2 mt-2  pb-2 ">
											<div className="col-lg-6">
												<Link
													className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
													to="/write-prescription"
												>
													<span className="bg-wrapper w-100">
														{" "}
														<img
															src={file}
															className="img-fluid pe-3"
															alt=""
														/>{" "}
														Write Prescription
													</span>
												</Link>
											</div>
											<div className="col-lg-6">
												<Link
													className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
													to="/physician-write-notes"
												>
													<span className="bg-wrapper w-100">
														{" "}
														<img
															src={file}
															className="img-fluid pe-3"
															alt=""
														/>{" "}
														Write Notes
													</span>
												</Link>
											</div>
										</div>
										<div className="row mt-4">
											<div className="col-lg-12">
												<Link
													className="color-view-details detail-physician-btn calender-bg  w-100 d-flex align-items-center justify-content-center dark-color"
													to="/physician-current-chat"
													state={{ tabName: state?.tabName }}
												>
													<span>
														<img src={chat} alt="" className="img-fluid" />
													</span>
													Open Chat
												</Link>
											</div>
										</div>
									</>
								) : null}
								{/* ======================== */}

								{getappointdetail?.booking_detail?.appointment_status ==
								"Past" ? (
									<>
										<div className="row border-top pt-2 mt-2  pb-2 ">
											<div className="col-lg-6">
												<Link
													className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
													to="/physician-prescription"
												>
													<span className="bg-wrapper w-100">
														{" "}
														<img
															src={file}
															className="img-fluid pe-3"
															alt=""
														/>{" "}
														View Prescription
													</span>
												</Link>
											</div>
											<div className="col-lg-6">
												<Link
													className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
													to="/physician-notes"
												>
													<span className="bg-wrapper w-100">
														{" "}
														<img
															src={file}
															className="img-fluid pe-3"
															alt=""
														/>{" "}
														View Notes
													</span>
												</Link>
											</div>
										</div>
										<div className="row mt-4">
											<div className="col-lg-12">
												<Link
													className="color-view-details detail-physician-btn calender-bg  w-100 d-flex align-items-center justify-content-center dark-color"
													to="/physician-current-chat"
												>
													<span>
														<img src={chat} alt="" className="img-fluid" />
													</span>
													View Chat
												</Link>
											</div>
										</div>
									</>
								) : null}
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PhysicianConsultationDetail;
